// NOTE: Due to having met and not met condition, we need to have a way to differentiate between them
export enum RuleConversationAutomationType {
  CONVERSATION_SCORE = 'CONVERSATION_SCORE',
  CONVERSATION_STATUS = 'CONVERSATION_STATUS',
  CONVERSATION_MANDATORY_QUESTIONS_MET = 'CONVERSATION_MANDATORY_QUESTIONS_MET',
  CONVERSATION_MANDATORY_QUESTIONS_NOT_MET = 'CONVERSATION_MANDATORY_QUESTIONS_NOT_MET'
}
